module.exports = __webpack_public_path__ + "img/Accessibility-settings_It.4ffe6995.png";